import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/common/Navbar';
import Footer from '../components/home/Footer';

const Sitemap: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      
      {/* Hero Section */}
      <div className="relative h-[30vh] min-h-[300px] bg-cover bg-center" style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('/images/sitemap-hero.jpg')`
      }}>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Sitemap</h1>
            <p className="text-xl max-w-2xl mx-auto px-4">Find your way around our website</p>
          </div>
        </div>
      </div>

      <div className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Main Pages */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4 text-[#C05B2A]">Main Pages</h2>
            <ul className="space-y-2">
              <li><Link to="/" className="text-gray-700 hover:text-[#C05B2A]">Home</Link></li>
              <li><Link to="/about" className="text-gray-700 hover:text-[#C05B2A]">About Us</Link></li>
              <li><Link to="/contact" className="text-gray-700 hover:text-[#C05B2A]">Contact</Link></li>
              <li><Link to="/gallery" className="text-gray-700 hover:text-[#C05B2A]">Gallery</Link></li>
            </ul>
          </div>

          {/* About Section */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4 text-[#C05B2A]">About</h2>
            <ul className="space-y-2">
              <li><Link to="/about/our-guides" className="text-gray-700 hover:text-[#C05B2A]">Our Guides</Link></li>
              <li><Link to="/about/philosophy" className="text-gray-700 hover:text-[#C05B2A]">Our Philosophy</Link></li>
              <li><Link to="/testimonials" className="text-gray-700 hover:text-[#C05B2A]">Testimonials</Link></li>
            </ul>
          </div>

          {/* Activities */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4 text-[#C05B2A]">Activities</h2>
            <ul className="space-y-2">
              <li><Link to="/activities" className="text-gray-700 hover:text-[#C05B2A]">All Activities</Link></li>
              <li><Link to="/activities/wildlife-viewing" className="text-gray-700 hover:text-[#C05B2A]">Wildlife Viewing</Link></li>
              <li><Link to="/activities/desert-exploration" className="text-gray-700 hover:text-[#C05B2A]">Desert Exploration</Link></li>
              <li><Link to="/activities/cultural-experiences" className="text-gray-700 hover:text-[#C05B2A]">Cultural Experiences</Link></li>
              <li><Link to="/activities/photography-tours" className="text-gray-700 hover:text-[#C05B2A]">Photography Tours</Link></li>
              <li><Link to="/activities/okavango-delta" className="text-gray-700 hover:text-[#C05B2A]">Okavango Delta</Link></li>
              <li><Link to="/activities/victoria-falls" className="text-gray-700 hover:text-[#C05B2A]">Victoria Falls</Link></li>
            </ul>
          </div>

          {/* Tours */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4 text-[#C05B2A]">Tours</h2>
            <ul className="space-y-2">
              <li><Link to="/tours" className="text-gray-700 hover:text-[#C05B2A]">All Tours</Link></li>
              <li><Link to="/tours/namibia-highlights" className="text-gray-700 hover:text-[#C05B2A]">Namibia Highlights Safari</Link></li>
              <li><Link to="/tours/big-five-safari" className="text-gray-700 hover:text-[#C05B2A]">Big Five Safari</Link></li>
              <li><Link to="/tours/namwild-safari" className="text-gray-700 hover:text-[#C05B2A]">Namwild Safari</Link></li>
              <li><Link to="/tours/walvisbay-excursion" className="text-gray-700 hover:text-[#C05B2A]">Walvisbay Excursions</Link></li>
              <li><Link to="/tours/namibia-botswana-victoria-falls" className="text-gray-700 hover:text-[#C05B2A]">Namibia, Botswana & Victoria Falls</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4 text-[#C05B2A]">Contact</h2>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-gray-700 hover:text-[#C05B2A]">Contact Us</Link></li>
              <li><Link to="/contact#booking" className="text-gray-700 hover:text-[#C05B2A]">Booking Inquiries</Link></li>
              <li><Link to="/contact#support" className="text-gray-700 hover:text-[#C05B2A]">Support</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h2 className="text-xl font-bold mb-4 text-[#C05B2A]">Legal</h2>
            <ul className="space-y-2">
              <li><Link to="/privacy-policy" className="text-gray-700 hover:text-[#C05B2A]">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-700 hover:text-[#C05B2A]">Terms of Service</Link></li>
              <li><Link to="/sitemap" className="text-gray-700 hover:text-[#C05B2A]">Sitemap</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Sitemap; 